import {
  MainSection,
  DefaultSection,
  Paragraph,
  SectionSubTitle,
  ListSection,
} from "./components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import "./privacyAndTerms.scss";

export const TermsOfUse = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handlePrivacyPolicyLink = () => {
    navigate("/PrivacyPolicy");
  };

  return (
    <div className="container-main-privacy-terms">
      <div className="section-container">
        <MainSection
          firstTilte={t("terms_of_use.main_section.first_tilte")}
          secondTilte={t("terms_of_use.main_section.second_title")}
          text={t("terms_of_use.main_section.paragraph_1")}
          secondText={t("terms_of_use.main_section.paragraph_2")}
          type="termsOfUse"
        />
        <DefaultSection title={t("terms_of_use.terms_section.title")}>
          <Paragraph text={t("terms_of_use.terms_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.terms_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.terms_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.terms_section.paragraph_4")} />
          <div>
            <span>
              {t("terms_of_use.terms_section.paragraph_5.first_text")}
            </span>
            <span className="text-link" onClick={handlePrivacyPolicyLink}>
              {t("terms_of_use.terms_section.paragraph_5.link_text")}
            </span>
            <span>
              {t("terms_of_use.terms_section.paragraph_5.second_text")}
            </span>
          </div>
          <Paragraph text={t("terms_of_use.terms_section.paragraph_6")} />
        </DefaultSection>

        <DefaultSection
          title={t("terms_of_use.update_use_terms_section.title")}
        >
          <Paragraph
            text={t("terms_of_use.update_use_terms_section.paragraph_1")}
          />
          <Paragraph
            text={t("terms_of_use.update_use_terms_section.paragraph_2")}
          />
          <Paragraph
            text={t("terms_of_use.update_use_terms_section.paragraph_3")}
          />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.services_section.title")}>
          <Paragraph text={t("terms_of_use.services_section.paragraph_1")} />
          <ListSection>
            <li>{t("terms_of_use.services_section.list.item_1")}</li>
            <li>{t("terms_of_use.services_section.list.item_2")}</li>
            <li>{t("terms_of_use.services_section.list.item_3")}</li>
          </ListSection>
          <Paragraph text={t("terms_of_use.services_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.services_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.services_section.paragraph_4")} />
          <Paragraph text={t("terms_of_use.services_section.paragraph_5")} />
          <Paragraph text={t("terms_of_use.services_section.paragraph_6")} />

          <SectionSubTitle
            text={t("terms_of_use.services_section.sub_section_1.title")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_1.paragraph_1")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_1.paragraph_2")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_1.paragraph_3")}
          />

          <SectionSubTitle
            text={t("terms_of_use.services_section.sub_section_2.title")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_2.paragraph_1")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_2.paragraph_2")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_2.paragraph_3")}
          />

          <SectionSubTitle
            text={t("terms_of_use.services_section.sub_section_3.title")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_3.paragraph_1")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_3.paragraph_2")}
          />

          <SectionSubTitle
            text={t("terms_of_use.services_section.sub_section_4.title")}
          />
          <Paragraph
            text={t("terms_of_use.services_section.sub_section_4.paragraph_1")}
          />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.software_section.title")}>
          <Paragraph text={t("terms_of_use.software_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.software_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.software_section.paragraph_3")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.content_section.title")}>
          <Paragraph text={t("terms_of_use.content_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.content_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.content_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.content_section.paragraph_4")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.use_section.title")}>
          <Paragraph text={t("terms_of_use.use_section.paragraph_1")} />

          <ListSection>
            <li>{t("terms_of_use.use_section.list.item_1")}</li>
            <li>{t("terms_of_use.use_section.list.item_2")}</li>
            <li>{t("terms_of_use.use_section.list.item_3")}</li>
            <li>{t("terms_of_use.use_section.list.item_4")}</li>
            <li>{t("terms_of_use.use_section.list.item_5")}</li>
            <li>{t("terms_of_use.use_section.list.item_6")}</li>
            <li>{t("terms_of_use.use_section.list.item_7")}</li>
            <li>{t("terms_of_use.use_section.list.item_8")}</li>
            <li>{t("terms_of_use.use_section.list.item_9")}</li>
            <li>{t("terms_of_use.use_section.list.item_10")}</li>
            <li>{t("terms_of_use.use_section.list.item_11")}</li>
            <li>{t("terms_of_use.use_section.list.item_12")}</li>
            <li>{t("terms_of_use.use_section.list.item_13")}</li>
            <li>{t("terms_of_use.use_section.list.item_14")}</li>
            <li>{t("terms_of_use.use_section.list.item_15")}</li>
          </ListSection>
          <Paragraph text={t("terms_of_use.use_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.use_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.use_section.paragraph_4")} />
          <Paragraph text={t("terms_of_use.use_section.paragraph_5")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.communication_section.title")}>
          <Paragraph
            text={t("terms_of_use.communication_section.paragraph_1")}
          />
          <Paragraph
            text={t("terms_of_use.communication_section.paragraph_2")}
          />
          <Paragraph
            text={t("terms_of_use.communication_section.paragraph_3")}
          />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.host_section.title")}>
          <Paragraph text={t("terms_of_use.host_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.host_section.paragraph_2")} />
          <ListSection>
            <li>{t("terms_of_use.host_section.list.item_1")}</li>
            <li>{t("terms_of_use.host_section.list.item_2")}</li>
          </ListSection>
        </DefaultSection>

        <DefaultSection
          title={t("terms_of_use.service_availability_section.title")}
        >
          <Paragraph
            text={t("terms_of_use.service_availability_section.paragraph_1")}
          />
          <Paragraph
            text={t("terms_of_use.service_availability_section.paragraph_2")}
          />
          <Paragraph
            text={t("terms_of_use.service_availability_section.paragraph_3")}
          />
          <Paragraph
            text={t("terms_of_use.service_availability_section.paragraph_4")}
          />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.support_service_section.title")}>
          <Paragraph
            text={t("terms_of_use.support_service_section.paragraph_1")}
          />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.clossing_section.title")}>
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_4")} />
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_5")} />
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_6")} />
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_7")} />
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_8")} />
          <Paragraph text={t("terms_of_use.clossing_section.paragraph_9")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.downgrade_section.title")}>
          <Paragraph text={t("terms_of_use.downgrade_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.downgrade_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.downgrade_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.downgrade_section.paragraph_4")} />
          <Paragraph text={t("terms_of_use.downgrade_section.paragraph_5")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.upgrade_section.title")}>
          <Paragraph text={t("terms_of_use.upgrade_section.paragraph_1")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.prices_section.title")}>
          <Paragraph text={t("terms_of_use.prices_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_4")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_5")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_6")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_7")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_8")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_9")} />
          <Paragraph text={t("terms_of_use.prices_section.paragraph_10")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.copyrigth_section.title")}>
          <Paragraph text={t("terms_of_use.copyrigth_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.copyrigth_section.paragraph_2")} />

          <ListSection>
            <li>{t("terms_of_use.copyrigth_section.list.item_1")}</li>
            <li>{t("terms_of_use.copyrigth_section.list.item_2")}</li>
            <li>{t("terms_of_use.copyrigth_section.list.item_3")}</li>
            <li>{t("terms_of_use.copyrigth_section.list.item_4")}</li>
          </ListSection>

          <Paragraph text={t("terms_of_use.copyrigth_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.copyrigth_section.paragraph_4")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.brands_section.title")}>
          <Paragraph text={t("terms_of_use.brands_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.brands_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.brands_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.brands_section.paragraph_4")} />
          <Paragraph text={t("terms_of_use.brands_section.paragraph_5")} />
          <Paragraph text={t("terms_of_use.brands_section.paragraph_6")} />
          <Paragraph text={t("terms_of_use.brands_section.paragraph_7")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.confidentiality_section.title")}>
          <Paragraph
            text={t("terms_of_use.confidentiality_section.paragraph_1")}
          />
          <Paragraph
            text={t("terms_of_use.confidentiality_section.paragraph_2")}
          />

          <ListSection>
            <li>{t("terms_of_use.confidentiality_section.list.item_1")}</li>
            <li>{t("terms_of_use.confidentiality_section.list.item_2")}</li>
            <li>{t("terms_of_use.confidentiality_section.list.item_3")}</li>
            <li>{t("terms_of_use.confidentiality_section.list.item_4")}</li>
          </ListSection>

          <Paragraph
            text={t("terms_of_use.confidentiality_section.paragraph_3")}
          />
          <Paragraph
            text={t("terms_of_use.confidentiality_section.paragraph_4")}
          />
          <Paragraph
            text={t("terms_of_use.confidentiality_section.paragraph_5")}
          />
          <Paragraph
            text={t("terms_of_use.confidentiality_section.paragraph_6")}
          />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.warranty_section.title")}>
          <Paragraph text={t("terms_of_use.warranty_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.warranty_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.warranty_section.paragraph_3")} />
          <Paragraph text={t("terms_of_use.warranty_section.paragraph_4")} />
          <Paragraph text={t("terms_of_use.warranty_section.paragraph_5")} />

          <ListSection>
            <li>{t("terms_of_use.warranty_section.list.item_1")}</li>
            <li>{t("terms_of_use.warranty_section.list.item_2")}</li>
            <li>{t("terms_of_use.warranty_section.list.item_3")}</li>
            <li>{t("terms_of_use.warranty_section.list.item_4")}</li>
            <li>{t("terms_of_use.warranty_section.list.item_5")}</li>
          </ListSection>
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.idemnity_section.title")}>
          <Paragraph text={t("terms_of_use.idemnity_section.paragraph_1")} />

          <ListSection>
            <li>{t("terms_of_use.idemnity_section.list.item_1")}</li>
            <li>{t("terms_of_use.idemnity_section.list.item_2")}</li>
            <li>{t("terms_of_use.idemnity_section.list.item_3")}</li>
          </ListSection>
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.applicable_law_section.title")}>
          <Paragraph
            text={t("terms_of_use.applicable_law_section.paragraph_1")}
          />
          <Paragraph
            text={t("terms_of_use.applicable_law_section.paragraph_2")}
          />
          <Paragraph
            text={t("terms_of_use.applicable_law_section.paragraph_3")}
          />
          <Paragraph
            text={t("terms_of_use.applicable_law_section.paragraph_4")}
          />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.aggremment_section.title")}>
          <Paragraph text={t("terms_of_use.aggremment_section.paragraph_1")} />
          <Paragraph text={t("terms_of_use.aggremment_section.paragraph_2")} />
          <Paragraph text={t("terms_of_use.aggremment_section.paragraph_3")} />
        </DefaultSection>

        <DefaultSection title={t("terms_of_use.original_terms_section.title")}>
          <Paragraph
            text={t("terms_of_use.original_terms_section.paragraph_1")}
          />
        </DefaultSection>
      </div>
    </div>
  );
};

export default TermsOfUse;
